if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}

if (!customElements.get("product-add-on")) {
  customElements.define(
    "product-add-on",
    class ProductAddOn extends HTMLElement {
      constructor() {
        super();

        this.addOnId = this.dataset.variantId;
        this.currentProduct = document.querySelector(
          ".product-variant-id"
        ).value;

        this.querySelector('.switch input').removeAttribute('disabled');
      }

      connectedCallback() {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (!this.querySelector("label input").checked) return;
          this.addOnId = this.dataset.variantId;
          this.currentProduct = document.querySelector(
            ".product-variant-id"
          ).value;

          setTimeout(() => {
            document.querySelector(".product-variant-id").value = this.addOnId;
            document.querySelector(".product-form__submit").click();
            document.querySelector(".product-variant-id").value =
              this.currentProduct;
          }, 1000);

          this.querySelector("label input").click();
        });
      }
    }
  );
}

if (!customElements.get("product-options-bracelet")) {
  var _html = `<li class="thumbnail-list__item media swiper-slide" data-media-position="[position]">
      <img src="[image]&amp;width=416" alt="[title]" 
      srcset="[image]&amp;width=54 54w, 
      [image]&amp;width=74 74w, 
      [image]&amp;width=104 104w, 
      [image]&amp;width=162 162w, 
      [image]&amp;width=208 208w, 
      [image]&amp;width=324 324w, 
      [image]&amp;width=416 416w" 
      width="416" height="416" loading="lazy">
    </li>`;

  var _html2 = `
      <li class="product__media-item swiper-slide">
        <div class="product-media-container global-media-settings gradient" style="--ratio: 1.0; --preview-ratio: 1.0; display: flex; align-items: center; justify-content: center;">
        <div class="product__media media media--transparent" style="width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;">          
          <img alt="[title]" src="[image]&amp;width=1946" srcset="[image]&amp;width=246 246w, [image]&amp;width=493 493w, [image]&amp;width=600 600w, [image]&amp;width=713 713w, [image]&amp;width=823 823w, [image]&amp;width=990 990w, [image]&amp;width=1100 1100w, [image]&amp;width=1206 1206w, [image]&amp;width=1346 1346w, [image]&amp;width=1426 1426w, [image]&amp;width=1646 1646w, [image]&amp;width=1946 1946w" width="1946" height="1946" loading="lazy" class="image-magnify-" sizes="(min-width: 1300px) 48000px, (min-width: 990px) calc(4000vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)" style="object-fit: contain !important; max-width: 100%; max-height: 100%; padding: 20px;">
        </div>
        </div>
      </li>
    `;
  var _html3 = `
      <ul class="product__media-list list-unstyled swiper-wrapper" role="list">
        [content]
      </ul>
      <div class="swiper-pagination large-up-hide medium-hide"></div>
      <div class="swiper-button-prev large-up-hide"></div>
      <div class="swiper-button-next large-up-hide"></div>
    `;
  
  customElements.define(
    "product-options-bracelet",
    class ProductOptionsBracelet extends HTMLElement {
      constructor() {
        super();
        this.product = null;
        this.galleryMedia = document.querySelector("#MediaGallery");
        this.inputs = this.querySelectorAll("input.option-value");
        this.data = JSON.parse(
          this.querySelector('[type="application/json"]')?.textContent
        );
   
        this.init();
      }

      init() {
        this.fistRowSelection();
        this.inputs.forEach((input) =>
          input.addEventListener("change", () => {
            this.handleInputChange(input);
          })
        );
      }

      connectedCallback() {
        this.optionSelectUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionSelect,
          (event) => {
            this.handleInputChange(event.input);
          }
        );

        this.productSelectUnsubscriber = subscribe(
          PUB_SUB_EVENTS.productSelect,
          (event) => {
            this.product = event.product;
            this.updateProductDetails(event.product);
            this.changeImages(event.key, event.product);
            this.updateGradePrices(event.key);
            this.setSelectedProductPrice(event.key, event.product);
          }
        );

        subscribe(PUB_SUB_EVENTS.cartUpdate, (obj) => {
            if (!localStorage.getItem('specialNote')) 
                return;
          const note = localStorage.getItem('specialNote').split('#')[0];
          const productId = localStorage.getItem('specialNote').split('#')[1];

          if (this.product.id != productId) 
            return;
            setTimeout(async () => {
                const body = JSON.stringify({ note });
                await fetch(`${routes.cart_update_url}`, {
                    ...fetchConfig(),
                    ...{ body },
                });
            localStorage.removeItem('specialNote');
            }, 1000);
        });

        const settingOption = this.querySelector('popup-opener.option-setting')?.cloneNode(true);
        const descriptionSection = document.querySelector('.product__description');
        if(settingOption) {
            settingOption.style.display = 'block';
            settingOption.classList.add('setting-description-section');
            if (descriptionSection) {
                descriptionSection.insertAdjacentElement('beforebegin', settingOption);
            }
        }

        this.initializeSelection();
      }

      replaceAll(string, search, replace) {
        return string.split(search).join(replace);
      }

      changeImages(key, product) {
        let imgSliderHTML = ``;
        let thumbHTML = ``;

        if (!product.images || product.images.length === 0) {
          
          imgSliderHTML = `
            <li class="product__media-item swiper-slide" style="width: 100%;">
              <div class="product-media-container global-media-settings gradient" style="--ratio: 1.0; --preview-ratio: 1.0; min-height: 500px; width: 100%;">
                <div class="product__media media media--transparent" style="width: 100%; height: 100%;">          
                  
                  <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; opacity: 0.5;">
                    <svg style="width: 55px; height: 55px; margin-bottom: 15px; color: inherit; opacity: 0.5;" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                    </svg>
                    <h3 style="margin: 0; padding: 0; color: inherit;">Image Coming Soon</h3>
                  </div>

                </div>
              </div>
            </li>
          `;

          thumbHTML = ``;
          this.galleryMedia.querySelector(".thumbnail-list")?.classList.add("hidden");

        } else {
          product.images.forEach((img, i) => {
            let h = _html2;
            h = this.replaceAll(h, "[image]", img);
            h = this.replaceAll(h, "[title]", product.name);
            imgSliderHTML += h;

            let h2 = _html;
            h2 = this.replaceAll(h2, "[image]", img);
            h2 = this.replaceAll(h2, "[title]", product.name);
            h2 = this.replaceAll(h2, "[position]", i + 1);
            thumbHTML += h2;
          });

          if (product.images.length < 2) {
            thumbHTML = ``;
            this.galleryMedia.querySelector(".thumbnail-list")?.classList.add("hidden");
          } else {
            this.galleryMedia.querySelector(".thumbnail-list")?.classList.remove("hidden");
          }
        }

        let slidetmph = _html3.split("[content]").join(imgSliderHTML);

        if(this.galleryMedia.querySelector(".thumbnail-list ul")) {
            this.galleryMedia.querySelector(".thumbnail-list ul").innerHTML = thumbHTML;
        }
        if(this.galleryMedia.querySelector(".main-image .swiper")) {
            this.galleryMedia.querySelector(".main-image .swiper").innerHTML = slidetmph;
        }
        if (product.id) {
            this.galleryMedia.setAttribute("data-product", product.id);
        }

        setTimeout(() => {
          const customGallery = document.querySelector('gallery-media');
          if (customGallery && typeof customGallery.init === 'function') {
            if (customGallery.swiper) {
              customGallery.swiper.destroy(true, true);
              customGallery.swiper = null;
            }
            if (customGallery.thumbswiper) {
              customGallery.thumbswiper.destroy(true, true);
              customGallery.thumbswiper = null;
            }
            customGallery.init();
          }
        }, 150);
      }

      disconnectedCallback() {
        if (this.optionSelectUnsubscriber) {
          this.optionSelectUnsubscriber();
        }
        if (this.productSelectUnsubscriber) {
          this.productSelectUnsubscriber();
        }
      }

      fistRowSelection() {
        const options = this.querySelectorAll(
          ".product-option--2 input.option-value"
        );
        if(!options.length) return;
        
        let currentKey = this.data.current["options-key"];

        options.forEach((opt) => {
          currentKey = currentKey.split("_").slice(0, 2);
          currentKey = `${currentKey.join("_")}_${opt.value}`;

          let availableProducts = [];
          if (!this.data.current["options-key"].startsWith(currentKey)) {
            availableProducts = this.data.products?.filter(
              (pr) =>
                pr["options-key"].startsWith(currentKey) &&
                pr.availability == "InStock"
            );
          }

          if (!availableProducts || !availableProducts.length) {
            opt.setAttribute("disabled", true);
            return;
          }
          availableProducts.sort((p1, p2) =>
            p1.price < p2.price ? -1 : p1.price > p2.price ? 1 : 0
          );

          if(this.querySelector(`.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`)) {
              this.querySelector(
                `.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`
              ).textContent = `${availableProducts[0].currencySymbol}${availableProducts[0].price}`;
          }

          const tag = availableProducts[0].tags.find(t => t.startsWith('mk')); 
          if(tag) {
              let tagValue = tag.split('mk_')[1].toLowerCase();  
              if (tagValue.toString().includes('alloy')) {
                tagValue = 'n-a-alloy';
              };
              if(this.querySelector(`.metal-carat--${tagValue} .diamond-quality`)) {
                  this.querySelector(`.metal-carat--${tagValue} .diamond-quality`).innerText = availableProducts[0].optionsValue.option2;
              }
          }

          try {
            let comparedPrice1 =
              availableProducts[0].comparedPrice == ""
                ? ""
                : parseFloat(
                    availableProducts[0].comparedPrice
                      .replace(",", "")
                      .replace(".", "")
                  ) * 100;
            
            const priceEl = this.querySelector(`.product-price--${opt.dataset.index}-${opt.dataset.elementIndex}`);
            if(priceEl) {
                priceEl.classList.remove("wpd-processed");
                priceEl.setAttribute("data-wpd-variant-compare-at-price", comparedPrice1);
                priceEl.setAttribute(
                "data-wpd-variant-price",
                parseFloat(
                    availableProducts[0].price.replace(",", "").replace(".", "")
                ) * 100
                );
                priceEl.setAttribute("data-wpd-variant-id", availableProducts[0].variant);
                priceEl.setAttribute(
                "data-wpd-product-handle",
                window.wpdExtensionIsProductPage?.handle || ""
                );
            }
          } catch (e) {}
        });

        this.disableAllOptions();
      }

      disableAllOptions() {
        let firstAvailable = this.querySelector(
          `.product-option--0 input.option-value:not([disabled])`
        );
        let options = this.querySelectorAll(`input.option-value`);
        if (!firstAvailable) {
          options.forEach((opt) => opt.setAttribute("disabled", true));
        }
      }

      handleInputChange(input) {
        let key = "";
        if (input == null) return;
        const index = parseInt(input.dataset.index);
        if (index == 0) {
          key = input.value;
        } else {
          key = this.getKeyFromPreviousSelections(index);
          key += `_${input.value}`;
        }
        
        if(this.querySelector(`.product-option__header-value--${index}`)) {
            this.querySelector(
            `.product-option__header-value--${index}`
            ).innerHTML = input.dataset.value;
        }
        
        if (input.classList.contains("last-option")) {
          return this.getProductByKey(key);
        }

        return this.triggerNextInputSelection(key, index + 1);
      }

      initializeSelection() {
        let firstAvailable = this.querySelector(
          `input.option-value:not([disabled])[data-index="0"]:checked`
        );
        if (!firstAvailable) {
          firstAvailable = this.querySelector(
            `input.option-value:not([disabled])[data-index="0"]`
          );
        }

        if(firstAvailable) {
            firstAvailable.checked = true;
            return publish(PUB_SUB_EVENTS.optionSelect, { input: firstAvailable });
        }
      }

      getKeyFromPreviousSelections(index) {
        let key = "";
        for (let i = 0; i < index; i++) {
          if (i != 0) key += "_";
          const checkedInput = this.querySelector(`input.option-value[data-index="${i}"]:checked`);
          if(checkedInput) key += checkedInput.value;
        }

        return key;
      }

      triggerNextInputSelection(key, index) {
        let Okey = key;
        let nextInputs = this.querySelectorAll(`input.option-value[data-index="${index}"]`);

        nextInputs.forEach((ipt) => {
          try {
              let k = key + "_" + ipt.value;
              if (!ipt.classList.contains('last-option')) {
                k += "_";
              }
              
              let productExists = this.checkProductsFromKey(k);
              const container = ipt.closest('.product-option__list-item');
              if (!productExists) {
                ipt.setAttribute("disabled", true);
                if (container) container.classList.add('hidden');
              } else {
                ipt.removeAttribute("disabled");
                if (container) container.classList.remove('hidden');
              }
          } catch (error) {}
        });

        let checkedInput = this.querySelector(`input.option-value:not([disabled])[data-index="${index}"]:checked`);
        if (checkedInput) {
          key += "_" + checkedInput.value;
          if(this.querySelector(`.product-option__header-value--${index}`)) {
              this.querySelector(`.product-option__header-value--${index}`).innerHTML = checkedInput.dataset.value;
          }
          if (checkedInput.classList.contains("last-option")) {
            if (this.hasProductsFromKey(key)) return this.getProductByKey(key);
            
            checkedInput.removeAttribute("checked");
            let alternative = null;
            nextInputs.forEach((ipt) => {
              let k = Okey + "_" + ipt.value;
              if (this.hasProductsFromKey(k)) { ipt.checked = true; alternative = ipt; }
            });

            if (alternative == null) {
              this.disableAddButton();
              let product = { name: "" };
              Okey.split("_").slice(0, -1).forEach((element, idx) => {
                  if (idx == 3 && this.data.current.collection) product.name += " " + this.data.current.collection;
                  product.name += ` ${element}`;
              });
              this.updateHeaderTitle(product);
            }
            if(alternative) return publish(PUB_SUB_EVENTS.optionSelect, { input: alternative });
          }
          return this.triggerNextInputSelection(key, index + 1);
        }

        let firstAvailable = this.querySelector(`input.option-value:not([disabled])[data-index="${index}"]`);
        if (firstAvailable == null) {
          this.disableAddButton();
          let product = { name: "" };
          Okey.split("_").slice(0, -1).forEach((element, idx) => {
              if (idx == 3 && this.data.current.collection) product.name += " " + this.data.current.collection;
              product.name += ` ${element.toLowerCase().replace("-", " ")}`;
          });
          this.updateHeaderTitle(product);
          return;
        }

        firstAvailable.checked = true;
        key += "_" + firstAvailable.value;
        if(this.querySelector(`.product-option__header-value--${index}`)) {
            this.querySelector(`.product-option__header-value--${index}`).innerHTML = firstAvailable.dataset.value;
        }
        
        if (firstAvailable.classList.contains("last-option")) return this.getProductByKey(key);
        return publish(PUB_SUB_EVENTS.optionSelect, { input: firstAvailable });
      }

      checkProductsFromKey(key) {
        try {
            let availableProducts = this.data.products?.filter(
              (pr) => {
                  if(!pr || !pr["options-key"]) return false; 
                  return pr["options-key"].startsWith(key) && pr.availability == "InStock";
              }
            );
            return availableProducts ? availableProducts.length : 0;
        } catch(err) {
            return 0;
        }
      }

      setSelectedProductPrice(key, product) {
        if (product.type == 'Rolex Bezels') return;
        let firstAvailable = this.querySelector(
          `input.option-value:not([disabled])[data-index="2"]:checked`
        );
        if (firstAvailable) {
          if(this.querySelector(`.product-price--${firstAvailable.dataset.index}-${firstAvailable.dataset.elementIndex}`)) {
              this.querySelector(
                `.product-price--${firstAvailable.dataset.index}-${firstAvailable.dataset.elementIndex}`
              ).textContent = `${product.currencySymbol}${product.price}`;
          }

            const tag = product.tags.find(t => t.startsWith('mk')); 
            if(tag) {
                let tagValue = tag.split('mk_')[1].toLowerCase();  
                if (tagValue.toString().includes('alloy')) {
                tagValue = 'n-a-alloy';
                };
                if(this.querySelector(`.metal-carat--${tagValue} .diamond-quality`)){
                    this.querySelector(`.metal-carat--${tagValue} .diamond-quality`).innerText = product.optionsValue.option2;
                }
            }
            
          let comparedPrice1 =
                product.comparedPrice == ""
                  ? ""
                  : parseFloat(
                      product.comparedPrice.replace(",", "").replace(".", "")
                    ) * 100;
           
           const priceEl = this.querySelector(`.product-price--${firstAvailable.dataset.index}-${firstAvailable.dataset.elementIndex}`);
           if(priceEl){
               priceEl.classList.remove("wpd-processed");
               priceEl.setAttribute("data-wpd-variant-compare-at-price", comparedPrice1);
               priceEl.setAttribute(
                    "data-wpd-variant-price",
                    parseFloat(product.price.replace(",", "").replace(".", "")) *
                    100
                );
               priceEl.setAttribute("data-wpd-variant-id", product.variant);
           }
        }
      }

      hasProductsFromKey(key) {
        let availableProducts = this.data.products?.filter((pr) =>
          pr["options-key"].startsWith(key)
        );
        return availableProducts ? availableProducts.length : 0;
      }

      getProductByKey(key) {
        let product = this.data.products?.find((pr) =>
          pr["options-key"] === key
        );

        if (!product) {
           product = this.data.products?.find((pr) =>
             pr["options-key"].startsWith(key + "_")
           );
        }

        if(product) {
            window.history.replaceState({}, '', product.url);
            return publish(PUB_SUB_EVENTS.productSelect, { product, key });
        } else {}
      }

      updateProductDetails(product) {
        this.updateHeaderPrice(product);
        this.updateAddButton(product);
        this.updateHeaderTitle(product);
        this.updateDecription(product);
        this.updateIconPicto(product);
        this.updateBreadcrumb(product);
        this.updateAddonInfo(product);
        this.updateFactoryTag(product);
        this.updateSKU(product.sku);
        this.updateSettingsDescription(product);
      }

      updateHeaderPrice(product) {
        document.querySelectorAll(".product-head__price .price").forEach((priceElement) => {
          priceElement.textContent = `${product.currencySymbol}${product.price}`;
        });

        document.querySelectorAll('.product-head__price .compare-price').forEach(compareElement => {
          if (product.comparedPrice && product.comparedPrice !== product.price) {
            compareElement.textContent = `${product.currencySymbol}${product.comparedPrice}`;
            compareElement.classList.remove('hidden');
          } else {
            compareElement.classList.add('hidden');
          }
        });

        const mobilePrice = document.querySelector(".product-price-mobile");
        if (mobilePrice) mobilePrice.textContent = `${product.currencySymbol}${product.price}`;
      }
      // updateHeaderPrice(product) {
      //   document
      //     .querySelectorAll(".product-head__price .price")
      //     .forEach((priceElement) => {
      //       priceElement.textContent = `${product.currencySymbol}${product.price}`;

      //       try {
      //         let comparedPrice1 =
      //           product.comparedPrice == ""
      //             ? ""
      //             : parseFloat(
      //                 product.comparedPrice.replace(",", "").replace(".", "")
      //               ) * 100;
      //         priceElement.classList.remove("wpd-processed");
      //         priceElement.setAttribute(
      //           "data-wpd-variant-compare-at-price",
      //           comparedPrice1
      //         );
      //         priceElement.setAttribute(
      //           "data-wpd-variant-price",
      //           parseFloat(product.price.replace(",", "").replace(".", "")) *
      //             100
      //         );
      //         priceElement.setAttribute("data-wpd-variant-id", product.variant);
      //         priceElement.setAttribute(
      //           "data-wpd-product-handle",
      //           window.wpdExtensionIsProductPage?.handle || ""
      //         );
      //       } catch (e) {}
      //     });
        
      //   if(document.querySelector(".product-price-mobile")) {
      //       document.querySelector(".product-price-mobile").textContent = `${product.currencySymbol}${product.price}`;
      //   }
        
      //   document
      //     .querySelectorAll(".product-availability")
      //     .forEach((productAvaibility) => {
      //       productAvaibility.className = `product-availability ${product.availability == "InStock" ? "product__in-stock" : "product__sold-out"}`;
      //     });
      // }

      updateAddonInfo(product) {
        if (document.querySelector(".product__add-on") == null) 
          return;

        document
          .querySelector(".product__add-on input")
          .removeAttribute("disabled");
        if (product.add_on == null) {
          document.querySelector(".product__add-on input").checked = false;
          document
            .querySelector(".product__add-on input")
            .setAttribute("disabled", true);
          return;
        }
        document.querySelector(".product__add-on").dataset.variantId =
          product.add_on.id;
        document.querySelector(".product__add-on .add-on__price").textContent =
          product.add_on.price;

        try {
          document.querySelector(".product__add-on .add-on__price").classList.remove("wpd-processed");
          document.querySelector(".product__add-on .add-on__price").setAttribute("data-wpd-variant-compare-at-price", "");
          document.querySelector(".product__add-on .add-on__price").setAttribute("data-wpd-variant-price",parseFloat(product.add_on.price.replace(",", "").replace(".", "").replace("$", "")) * 100);
          document.querySelector(".product__add-on .add-on__price").setAttribute("data-wpd-variant-id", product.add_on.id);
          document.querySelector(".product__add-on .add-on__price").setAttribute("data-wpd-product-handle", this.product.handle);
        } catch (e) {}
      }

      updateDecription(product) {
        if (document.querySelector(".product__description") && product.description) {
            document.querySelector(".product__description").innerHTML = product.description;
        }
      }

      updateIconPicto(product) {
        if (product.featured_image !== null && this.querySelector(".icon-picto img"))
          this.querySelector(".icon-picto img").setAttribute(
            "src",
            product.featured_image
          );
      }

      updateGradePrices(key) {
        if (this.querySelector('.grade-price') == null) return;

        let partialKey = key.split("_");
        let baseKey = partialKey[0]; 

        const options = this.querySelectorAll(
          ".option-metal-karat input.option-value, .option-era-bracelet input.option-value"
        );

        options.forEach((option) => {
          let value = option.value;
          let optionIndex = parseInt(option.dataset.index);
          
          let testKeyArray = key.split("_");
          testKeyArray[optionIndex] = value;
          let updatedKey = testKeyArray.join("_");

          let productAvailable = this.data.products.filter((product) =>
  product["options-key"] === updatedKey || product["options-key"].startsWith(updatedKey + "_")
);

          if (productAvailable.length > 0) {
            let product = productAvailable[0];
            
            const tag = product.tags.find(t => t.startsWith('mk')); 
            if(tag) {
                let tagValue = tag.split('mk_')[1].toLowerCase(); 
                if (tagValue.toString().includes('alloy')) {
                  tagValue = 'n-a-alloy';
                };
                if(this.querySelector(`.metal-carat--${tagValue} .diamond-quality`)) {
                    this.querySelector(`.metal-carat--${tagValue} .diamond-quality`).innerText = product.optionsValue.option2;
                }
            }

            const priceElement = document.querySelector(`.product-option__list-item--${value} .grade-price`);
            
            if (priceElement) {
                priceElement.innerHTML = `${product.currencySymbol}${product.price}`;

                const gradePriceElement = document.querySelector(`.product-option__list-item--${value} .grade-price`);
                  const gradeCompareElement = document.querySelector(`.product-option__list-item--${value} .compare-price`);

                  if (gradePriceElement) {
                      gradePriceElement.innerHTML = `${product.currencySymbol}${product.price}`;
                  }

                  if (gradeCompareElement) {
                      if (product.comparedPrice && product.comparedPrice !== product.price) {
                          gradeCompareElement.innerHTML = `${product.currencySymbol}${product.comparedPrice}`;
                          gradeCompareElement.classList.remove('hidden');
                      } else {
                          gradeCompareElement.classList.add('hidden');
                      }
                  }
            }
          } else {
            if (priceElement) {
              priceElement.innerHTML = ''; 
            }
          }
        });
      }

      updateAddButton(product) {
        let forms = document.querySelectorAll(".product-form");
        forms.forEach((form) => {
          if(form.querySelector('[name="id"]')) form.querySelector('[name="id"]').value = product.variant;

          if (product.availability == "InStock") {
            if(form.querySelector('[name="add"] span:first-child')) form.querySelector('[name="add"] span:first-child').innerHTML = this.data.strings.add_to_cart;
            if(form.querySelector('[name="add"]')) form.querySelector('[name="add"]').removeAttribute("disabled");
            return;
          }

          if(form.querySelector('[name="add"] span:first-child')) form.querySelector('[name="add"] span:first-child').innerHTML = this.data.strings.sold_out;
          if(form.querySelector('[name="add"]')) form.querySelector('[name="add"]').setAttribute("disabled", true);
          return;
        });
      }

      disableAddButton() {
        let forms = document.querySelectorAll(".product-form");
        forms.forEach((form) => {
          if(form.querySelector('[name="add"]')) form.querySelector('[name="add"]').setAttribute("disabled", true);
        });
      }

      updateHeaderTitle(product) {
        const productNames = document.querySelectorAll(
          ".product-head__title-keys"
        );
        productNames.forEach((productName) => {
          if(productName && product.name) productName.innerHTML = product.name;
        });
      }

      updateSKU(sku) {
        if(document.querySelector(".product__sku") && sku) {
            document.querySelector(".product__sku").innerHTML = `<span class="visually-hidden">SKU:</span>${sku}`;
        }
      }

      updateSettingsDescription(product) {
        if (document.querySelector(".setting-description-section .option-value") && product.optionsValue?.option1) {
            document.querySelector(".setting-description-section .option-value").innerText = product.optionsValue.option1;
        }
      }

      updateBreadcrumb(product) {
        if(document.querySelector(".breadcrumbs [aria-current]") && product.name) {
            document.querySelector(".breadcrumbs [aria-current]").innerText = product.name;
        }
      }

      updateFactoryTag(product) {
        if(!product.tags) return;
        if(product.tags.includes("Factory")) {
          this.querySelector(".product-tag__factory")?.classList.remove("hidden");
          if(document.querySelector('.type-blank-bezel')) document.querySelector('.type-blank-bezel').style.display = 'flex';
        } else {
            if(document.querySelector('.type-blank-bezel')) document.querySelector('.type-blank-bezel').style.display = 'none';
            this.querySelector(".product-tag__factory")?.classList.add("hidden");
        }
      }
    }
  );
}